<template>
  <footer class="shell-footer">
    <v-sheet color="secondary py-7">
      <v-container class="py-0">
        <div class="d-flex justify-center pb-6">
          <img
            :height="sm ? `80px` : `138px`"
            class="d-block"
            src="../../assets/img/logo-outline.svg"
            alt="Tenório Marcas e Patentes"
          />
        </div>
        <div class="social">
          <div class="d-flex justify-center align-center">
            <div
              v-for="({ text, link, icon, size }, keySocial) in social"
              :key="keySocial"
              class="d-inline-flex"
            >
              <v-btn
                class="text-caption text-lg-body-1 white--text ml-4"
                :href="link"
                target="_blank"
                min-width="auto"
                color="rgba(255, 255, 255, 0.13)"
                small
                :title="text"
                depressed
                rounded
                fab
              >
                <v-icon :size="size">{{ icon }}</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <div
          class="
            d-flex
            flex-column
            justify-space-between
            align-center
            text-center
          "
        >
          <div class="white--text text-caption mt-5">
            Copyright © {{ year }}.
            <b class="font-weight-bold"> {{ informations.name }}</b>
            <span class="d-block d-sm-inline-block">
              Todos os direitos reservados.
            </span>
          </div>
          <a
            class="d-flex mt-4"
            href="https://www.mrxweb.com.br/"
            target="_blank"
          >
            <img
              class="shell-footer-logo"
              src="../../assets/img/mrxweb.svg"
              alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
              title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
              :height="sm ? `16px` : `24px`"
            />
          </a>
        </div>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { getContact } from "../../utils/getContact";
import { getSocial } from "../../utils/getSocial";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contacts() {
      return getContact(this.informations);
    },
    social() {
      return getSocial(this.informations);
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>
